import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import arTranslation from './ar-AR.json';
// import caTranslation from './ca.json';
// import deTranslation from './de-DE.json';
import elTranslation from './el-EL.json';
import enTranslation from './en-US.json';
import esTranslation from './es-ES.json';
import frTranslation from './fr-FR.json';
// import heTranslation from './he-IL.json';
// import hiTranslation from './hi-IN.json';
// import itTranslation from './it-IT.json';
// import phiTranslation from './phi.json';
// import plTranslation from './pl-PL.json';
// import ptTranslation from './pt-PT.json';
// import roTranslation from './ro-RO.json';
// import ruTranslation from './ru-RU.json';
import thTranslation from './th-TH.json';
// import trTranslation from './tr-TR.json';
// import viTranslation from './vi-VN.json';
// import zhTranslation from './zh-CN.json';
import fallbackTranslation from './fallback-translations.json';
import { LANGUAGES } from '../consts';
var resources = {
    fallback: { translation: fallbackTranslation },
    // ar: { translation: arTranslation },// arabic
    // ca: { translation: caTranslation },
    // de: { translation: deTranslation },
    el: { translation: elTranslation }, // greek
    en: { translation: enTranslation },
    es: { translation: esTranslation }, // spanish
    fr: { translation: frTranslation },
    // he: { translation: heTranslation },
    // hi: { translation: hiTranslation },
    // it: { translation: itTranslation },
    // phi: { translation: phiTranslation },
    // pl: { translation: plTranslation }, // polish
    // pt: { translation: ptTranslation },
    // ro: { translation: roTranslation }, // romanian
    // ru: { translation: ruTranslation },
    th: { translation: thTranslation },
    // tr: { translation: trTranslation },
    // vi: { translation: viTranslation },
    // zh: { translation: zhTranslation },
};
i18n
    .use(initReactI18next)
    .init({
    resources: resources,
    lng: 'en',
    fallbackLng: 'fallback',
    interpolation: {
        escapeValue: false,
    },
});
export var isRTL = function () {
    var currentLanguage = i18n.language;
    var lang = Object.values(LANGUAGES).find(function (l) { return l.languageTag === currentLanguage; });
    return lang.isRTL;
};
export var t = i18n.t;
export var changeLanguage = function (language) {
    i18n.changeLanguage(language);
    return { language: i18n.language, isRTL: isRTL() };
};
export default i18n;
//# sourceMappingURL=multi-lang.service.js.map